<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  presetId: {
    type: String,
    required: true,
  },
  assistantId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['synced']);

const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
const isSyncing = ref(false);

const handleConfirm = async () => {
  isSyncing.value = true;
  try {
    const result = await store.dispatch(
      'captainAssistants/syncBusinessPreset',
      {
        presetId: props.presetId,
        assistantId: props.assistantId,
      }
    );
    useAlert(
      t('CAPTAIN.ASSISTANTS.SCENARIOS.SYNC_PRESET.SUCCESS_MESSAGE', {
        created: result?.created?.length ?? 0,
        updated: result?.updated?.length ?? 0,
      })
    );
    emit('synced');
    dialogRef.value?.close();
  } catch (error) {
    useAlert(
      error?.message ||
        t('CAPTAIN.ASSISTANTS.SCENARIOS.SYNC_PRESET.ERROR_MESSAGE')
    );
  } finally {
    isSyncing.value = false;
  }
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('CAPTAIN.ASSISTANTS.SCENARIOS.SYNC_PRESET.TITLE')"
    :description="t('CAPTAIN.ASSISTANTS.SCENARIOS.SYNC_PRESET.DESCRIPTION')"
    :confirm-button-label="
      t('CAPTAIN.ASSISTANTS.SCENARIOS.SYNC_PRESET.CONFIRM')
    "
    :is-loading="isSyncing"
    :disable-confirm-button="isSyncing"
    @confirm="handleConfirm"
  >
    <div class="flex flex-col gap-3 text-sm">
      <div class="flex flex-col gap-1">
        <span class="font-medium text-n-slate-12">
          {{ t('CAPTAIN.ASSISTANTS.SCENARIOS.SYNC_PRESET.KEEPS_TITLE') }}
        </span>
        <span class="text-n-slate-11">
          {{ t('CAPTAIN.ASSISTANTS.SCENARIOS.SYNC_PRESET.KEEPS_BODY') }}
        </span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="font-medium text-n-slate-12">
          {{ t('CAPTAIN.ASSISTANTS.SCENARIOS.SYNC_PRESET.REPLACES_TITLE') }}
        </span>
        <span class="text-n-slate-11">
          {{ t('CAPTAIN.ASSISTANTS.SCENARIOS.SYNC_PRESET.REPLACES_BODY') }}
        </span>
      </div>
    </div>
  </Dialog>
</template>
